import { getXCLEARCorrelationInfo } from '@api/utils'

export const baseLookup = async (
  key: string
): Promise<{ label: string; value: any }[]> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_LOOKUP_API_ENDPOINT}/lookup?categories=${key}`,
    {
      headers: {
        'X-CLEAR-CorrelationInfo': getXCLEARCorrelationInfo(),
      },
    }
  )

  const data = await response.json()

  return data[0].values.map((x: any) => ({
    label: x.text,
    value: x.key,
  }))
}
